import React from 'react';
import classes from './Title.module.scss';

export const Title = (props) => {
  return (
    <div className={`${props.className} ${classes.title}`}>{props.text}</div>
  );
}
